import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "../../../shared/i18n";

export default class RedFlagForm extends BaseModel {
  red_flag_comment = ''

  rules = {
    red_flag_comment: 'required'
  };

  attributeLabels = {
    red_flag_comment: i18n.t('Red Flag Comment'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}